var yourAreaInit = function () {
	var addressSelect = $('#select-addressOptions select');
	var servicesList = $('#servicesList');
	var yourAreaSearchForm = $('form.m-yourAreaSearch');

	// if services list exists push focus to first tab
	if (servicesList.length) {
				$('html, body').animate({
					scrollTop: $(servicesList).offset().top
				}, 300);

				servicesList.focus();
		return;
	}  

	// if address selector exists but no results, then push focus to it
	if (addressSelect.length) {
		$('html, body').animate({
			scrollTop: $(yourAreaSearchForm).offset().top
		}, 300);
		addressSelect.focus();
	}
}